<div class="card card-accent-info">
  <div class="card-body">
    <div echarts class="demo-chart" [options]="chartOptions" (chartClick)="onChartClick($event)"></div>
  </div>
</div>